export default __webpack_public_path__ + "static/media/IBMAttachment.bd9f714d.svg";